

































































































import { AllGeeksSingleSelect, AllAchievementTypesSingleSelect } from '@/components';
import { asyncSelectMixin } from '@/shared';
import { buildGeekName } from '@/utils';
import { collapseMixin } from '@/shared';
import { typedStore, Actions } from '@/store';
import { AchievementHistory, AchievementsHistoryFilters } from '@/models/admin-panel';
import { AchievementType, GeekItem } from '@/models';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import Multiselect from 'vue-multiselect';

export default mixins(collapseMixin, asyncSelectMixin(
  Actions.achievements.resetAchievementTypes,
  Actions.achievements.fetchFilteredAchievements)).extend({
  name: 'AchievementsHistoryTab',
  components: {
    AllAchievementTypesSingleSelect,
    AllGeeksSingleSelect,
    Multiselect,
  },
  data() {
    return {
      requestStatusIconMap: {
        rejected: 'log-icon-close',
        pending: 'log-icon-pending',
        ordered: 'log-icon-pending',
        confirmed: 'log-icon-pending',
        accepted: 'log-icon-check',
      },
      filters: {
        immediate: {
          geekId: null as unknown as string,
          achievementTypeId: null as unknown as string,
        } as AchievementsHistoryFilters,
      },
      loader: {
        isHistoryPending: false,
      },
    };
  },
  computed: {
    collapsibleItems(): AchievementHistory[] {
      return typedStore(this).state.achievements.achievementsHistory;
    },
    areMoreItemsAvailable(): boolean {
      return this.collapsibleItems.length < typedStore(this).state.achievements.achievementsCount.achievementsCount
        && this.collapsibleItems.length > 0;
    },
  },
  async created(): Promise<void> {
    this.loader.isHistoryPending = true;

    try {
      await this.$store.dispatch(Actions.achievements.fetchAllAchievements);
    } finally {
      this.loader.isHistoryPending = false;
    }
  },
  methods: {
    async fetchHistory() {
      this.loader.isHistoryPending = true;
      try {
        await this.$store.dispatch(Actions.achievements.fetchAchievementsHistory, this.filters.immediate);
      } finally {
        this.loader.isHistoryPending = false;
      }
    },
    async fetchMore() {
      this.loader.isHistoryPending = true;
      try {
        await this.$store.dispatch(Actions.achievements.fetchMoreAchievementsHistory, this.filters.immediate);
      } finally {
        this.loader.isHistoryPending = false;
      }
    },
    async preselectRequestedForAchievementType() {
      const preselectedAchievementTypeId = this.$route.query.requestedForAchievementTypeId;
      if (preselectedAchievementTypeId) {
        const achievementType = await this.$store.dispatch(
          Actions.achievements.getAchievementTypeBasicInfo, preselectedAchievementTypeId) as AchievementType;
        (this.$refs.requestedForAchievementType as any)
          .selectedAchievementType = {...achievementType, label: achievementType.name} as AchievementType
          & { label: string };
        // watcher is invoked - no need to fetch data
        return;
      }

      await this.fetchHistory();
    },
    updateRequestedFor(selectedGeek: GeekItem) {
      this.filters.immediate.geekId = selectedGeek ? selectedGeek.id : (null as unknown as string);
    },
    updateSelectedAchievementType(selectedAchievementType: AchievementType) {
      this.filters.immediate.achievementTypeId =
      selectedAchievementType ? selectedAchievementType.id : (null as unknown as string);
    },
    buildGeekName,
  },
  watch: {
    'filters.immediate': {
      handler(this: any) {
        this.fetchHistory();
      },
      deep: true,
    },
  },
});
